import { render, staticRenderFns } from "./ReturnIcon.vue?vue&type=template&id=9307304c"
import script from "./ReturnIcon.vue?vue&type=script&lang=ts"
export * from "./ReturnIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports